import script from "./MessageSendDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageSendDialog.vue?vue&type=script&setup=true&lang=js"

import "./MessageSendDialog.vue?vue&type=style&index=0&id=6b346971&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b346971"]])

export default __exports__